import { Cart } from "@commercetools/platform-sdk"
import { TFunction } from "i18next"
import { ErrorType } from "../../../error/ErrorType"
import { PaymentProvider } from "../../payment/PaymentProviderState"
import { CartValidationBase } from "../../validation/FormValidator"
import {
  CartValidationResult,
  cartError
} from "../../validation/ValidationError"

export class EmptyPaymentValidation extends CartValidationBase {
  private readonly errorMessage: CartValidationResult | undefined
  constructor(t: TFunction, currentPaymentProvider: PaymentProvider[]) {
    super("EmptyPaymentProviderValidation")
    this.errorMessage =
      currentPaymentProvider.length === 0
        ? cartError(ErrorType.PaymentError, {
            title: t("checkout:paymentFailedTitle"),
            message: t("checkout:paymentFailedMessage")
          })
        : undefined
  }

  validate(cart: Cart): CartValidationResult {
    return this.errorMessage || super.validate(cart)
  }

  save(cart: Cart): CartValidationResult {
    return this.errorMessage || super.save(cart)
  }
}
